import ErrorMessage from 'components/ErrorMessage'
import React from 'react'

const OSelect = (props) => {
	const { wrapperClassName, name, inputLabel, placeholder, register, errors, requiredMark, options = [], disabled, ...rest } = props

	return (
		<div className={wrapperClassName ?? 'relative z-0 mb-6 w-full group'}>
			<label htmlFor={name} className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
				{inputLabel} {requiredMark ? <span className='text-red-600'>*</span> : null}
			</label>
			<select
				id={name}
				name={name}
				disabled={disabled}
				className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
				{...register}
				{...rest}
			>
				{placeholder ? <option value=''>{placeholder}</option> : null}
				{options.map((opt) => (
					<option key={opt.value} value={opt.value}>{opt.key}</option>
				))}
			</select>
			<ErrorMessage message={errors?.[name]?.message} />
		</div>
	)
}

export default OSelect
